/* =============================================================
   arije — Frise chronologique
   Vanilla JS, aucune dependance.
   ============================================================= */
(function () {
  'use strict';
  if (window.__arijeFrise) return;
  window.__arijeFrise = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function desktop() { return window.matchMedia('(min-width: 990px)').matches; }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  var tickers = [];
  var running = false;
  function loop() {
    for (var i = 0; i < tickers.length; i++) {
      try { tickers[i](); } catch (e) { /* noop */ }
    }
    if (tickers.length) requestAnimationFrame(loop); else running = false;
  }
  function addTicker(fn) {
    tickers.push(fn);
    if (!running) { running = true; requestAnimationFrame(loop); }
  }

  /* ---------------------------------------------------------
     Apparitions
     --------------------------------------------------------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.fr:not([data-fr-rev]), .fr__item:not([data-fr-rev])');
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.classList.add('is-in');
        el.setAttribute('data-fr-rev', '');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-fr-rev', '');
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------
     Carrousel (mise en page horizontale)
     Ne touche pas au defilement vertical de la page.
     --------------------------------------------------------- */
  function initCarousel(root) {
    var blocks = (root || document).querySelectorAll('.fr--horizontale:not([data-fr-ready])');
    Array.prototype.forEach.call(blocks, function (fr) {
      fr.setAttribute('data-fr-ready', '');
      var rail = fr.querySelector('.fr__rail');
      var prev = fr.querySelector('.fr__nav--prev');
      var next = fr.querySelector('.fr__nav--next');
      var axis = fr.querySelector('.fr__axis span');
      if (!rail) return;

      function maxScroll() { return Math.max(0, rail.scrollWidth - rail.clientWidth); }

      function sync() {
        var max = maxScroll();
        var p = max ? rail.scrollLeft / max : 0;
        if (axis) axis.style.setProperty('--fr-progress', p.toFixed(4));
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        var useless = max < 4;
        [prev, next].forEach(function (b) { if (b) b.hidden = useless; });
      }

      function step() {
        var card = rail.querySelector('.fr__item');
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card ? card.offsetWidth + gap : rail.clientWidth * 0.8;
      }

      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: REDUCED ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: REDUCED ? 'auto' : 'smooth' }); });

      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', debounce(sync, 150));
      window.addEventListener('load', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------
     Epinglee : la section se fige, les cartes defilent
     --------------------------------------------------------- */
  function initPinned(root) {
    var blocks = (root || document).querySelectorAll('.fr--epinglee:not([data-fr-ready])');
    Array.prototype.forEach.call(blocks, function (fr) {
      fr.setAttribute('data-fr-ready', '');
      var track = fr.querySelector('.fr__track');
      var viewport = fr.querySelector('.fr__viewport');
      var rail = fr.querySelector('.fr__rail');
      var axis = fr.querySelector('.fr__axis span');
      var items = fr.querySelectorAll('.fr__item');
      if (!track || !viewport || !rail) return;

      var distance = 0;

      function measure() {
        if (!desktop() || REDUCED) {
          track.style.height = '';
          rail.style.transform = '';
          distance = 0;
          return;
        }
        distance = Math.max(0, rail.scrollWidth - viewport.clientWidth);
        track.style.height = (window.innerHeight + distance) + 'px';
      }

      function render() {
        if (!distance) return;
        var rect = track.getBoundingClientRect();
        var total = track.offsetHeight - window.innerHeight;
        var p = clamp(-rect.top / (total || 1), 0, 1);
        rail.style.transform = 'translate3d(' + (-p * distance).toFixed(2) + 'px,0,0)';
        if (axis) axis.style.setProperty('--fr-progress', p.toFixed(4));

        var vw = window.innerWidth;
        Array.prototype.forEach.call(items, function (it) {
          var r = it.getBoundingClientRect();
          it.classList.toggle('is-near', r.left < vw * 0.92 && r.right > vw * 0.04);
        });
      }

      measure();
      addTicker(render);
      window.addEventListener('resize', debounce(measure, 200));
      window.addEventListener('load', measure);
    });
  }

  function init(root) {
    initCarousel(root);
    initPinned(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.fr__item') : null;
    if (item) item.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  });

  window.ArijeFrise = { init: init };
})();
